import { IHomeAction, IHomeState, upgradeStatus } from './home.types'
import { HomeConstants } from './home.constants'

export const initialHomeState: IHomeState = {
  pcrDocs: [],
  pcrId: '',
  pcr: null,
  filteredPCRDocs: [],
  filter: {
    showClearFiltersButton: false,
    incompleteFilterOn: false,
    completeFilterOn: false,
    needsReviewFilterOn: false,
  },
  upgradeStatus: upgradeStatus.IN_PROGRESS,
  addressTypeSelected: 0,
  hideComponent: false,
  isPCROpening: false,
  isPCRClosing: false,
  isPCRError: false,
}

export function homeReducer(state: IHomeState = initialHomeState, action: IHomeAction): IHomeState {
  switch (action.type) {
    case HomeConstants.HOME_NOT_IMPLEMENTED:
      alert('Not implemented')
      return state
    case HomeConstants.UPGRADE_PCR:
      return { ...state, pcrId: action.pcr?.pcrId, pcr: action.pcr }
    case HomeConstants.SET_PCR_LIST:
      return { ...state, pcrDocs: action.docs, filteredPCRDocs: action.docs }
    case HomeConstants.SET_FILTERED_PCR_LIST:
      return { ...state, filteredPCRDocs: action.docs }
    case HomeConstants.ON_SELECT_PCR:
      return { ...state, pcrId: action.pcr?.pcrId, pcr: action.pcr }
    case HomeConstants.SET_INCOMPLETE_FILTER:
      return {
        ...state,
        filteredPCRDocs: action.filteredPCRDocs,
        filter: {
          ...state.filter,
          incompleteFilterOn: !state.filter.incompleteFilterOn,
          showClearFiltersButton: action.showClearFiltersButton,
        },
      }
    case HomeConstants.SET_COMPLETE_FILTER:
      return {
        ...state,
        filteredPCRDocs: action.filteredPCRDocs,
        filter: {
          ...state.filter,
          completeFilterOn: !state.filter.completeFilterOn,
          showClearFiltersButton: action.showClearFiltersButton,
        },
      }
    case HomeConstants.SET_NEEDS_REVIEW_FILTER:
      return {
        ...state,
        filteredPCRDocs: action.filteredPCRDocs,
        filter: {
          ...state.filter,
          needsReviewFilterOn: !state.filter.needsReviewFilterOn,
          showClearFiltersButton: action.showClearFiltersButton,
        },
      }
    case HomeConstants.CLEAR_FILTERS:
      return {
        ...state,
        filter: {
          showClearFiltersButton: false,
          incompleteFilterOn: false,
          completeFilterOn: false,
          needsReviewFilterOn: false,
        },
        filteredPCRDocs: state.pcrDocs,
      }
    case HomeConstants.SET_NEW_PCR:
      return { ...state, pcrId: action.pcr?.pcrId, pcr: action.pcr }
    case HomeConstants.SET_PCRID:
      return { ...state, pcrId: action.pcrId }
    case HomeConstants.SET_PCR:
      return { ...state, pcr: action.pcr }
    case HomeConstants.DELETE_PCR:
      return { ...state, pcrId: action.pcrId }
    case HomeConstants.SET_UPGRADE_STATUS:
      return { ...state, upgradeStatus: action.upgradeStatus }
    case HomeConstants.SET_ADDRESS_TYPE:
      return { ...state, addressTypeSelected: action.addressTypeSelected }
    case HomeConstants.SET_IS_PCR_OPENING:
      return { ...state, isPCROpening: action.isPCROpening }
    case HomeConstants.SET_IS_PCR_CLOSING:
      return { ...state, isPCRClosing: action.isPCRClosing }
    case HomeConstants.SET_IS_PCR_ERROR:
      return { ...state, isPCRError: action.isPCRError }
    case HomeConstants.CLEAR_SELECTED_PCR:
      return { ...state, pcrId: '', pcr: null }
    case HomeConstants.RESET_HOME_STATE:
      return { ...state, isPCRError: false }
    default:
      return state
  }
}
